<form [formGroup]="userForm" (ngSubmit)="save()" *ngIf="user">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'fullname-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.NAME' | translate }} *</label>
        <div class="col-sm-7">
          <input type="text" [class]="'form-control'" [id]="'fullname-' + user.id" formControlName="fullname"
            [readonly]="(currentUser.roleId === 2 && currentUser.profileId===2) ? true : false">
          <hbo-control-messages [control]="userForm.get('fullname')!"></hbo-control-messages>
        </div>
      </div>
      <div class="row mb-3">
        <label [for]="'email-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.EMAIL' | translate }} *</label>
        <div class="col-sm-7">
          <input type="text" [class]="action === 'create' ? 'form-control' : 'form-control-plaintext'"
            [id]="'email-' + user.id" formControlName="email">
          <hbo-control-messages [control]="userForm.get('email')!"></hbo-control-messages>
        </div>
      </div>
      <div class="row mb-3">
        <label [for]="'username-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.USERNAME' | translate }} *</label>
        <div class="col-sm-7">
          <input type="text" [class]="action === 'create' ? 'form-control' : 'form-control-plaintext'"
            [id]="'username-' + user.id" formControlName="username">
          <hbo-control-messages [control]="userForm.get('username')!"></hbo-control-messages>
        </div>
      </div>
      <div class="row mb-3" *ngIf="action === 'detail'">
        <label [for]="'password-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.PASSWORD' | translate }} *</label>
        <div class="col-sm-7">
          <div class="border p-2 text-center cursor-pointer" style="max-width: 220px;" (click)="changePassword()">
            <img src="assets/images/change_password.svg" alt="">
            {{ 'USER.PASSWORD_CHANGE' | translate }}
          </div>
        </div>
      </div>

      <small>* {{ 'COMMON.MANDATORY' | translate }}</small>
    </div>

    <div class="col-6">

      <div class="row mb-3">
        <label [for]="'entity-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.ENTITY' | translate }} *</label>
        <div *ngIf="action !== 'create' && (!entity || userForm.disabled)" class="col-sm-7 align_middle">
          {{user.entity.name}}
        </div>
        <div *ngIf="((action === 'create') || ( entity && entities.length)) && !userForm.disabled" class="col-sm-7">
          <!--<hbo-single-select-multi-level [tree]="entities" [userEntity]="user"
            [typeData]="action === 'create' ?  'newUser': 'user'"
            [max]="action === 'create' ? reactiveToRole : entity.entityTypeId" [selection]="entity"
            formControlName="entityId">
          </hbo-single-select-multi-level>-->
          <app-basic-virtual-scroll *ngIf="selectorVisible && configSvc.currentConfigValue.childEntities"
            [customTreeNode]="entities" [entityId]="persistEntityId" (callback)="onChange($event,'entity')"
            [typeData]="action === 'create' ? 'newUser': 'user'"
            [entity]="action !== 'create' ? persistEntityId : userForm.get('entityId')!.value"
            [currentEntityId]="userForm.get('entityId')!.value| toString"></app-basic-virtual-scroll>
          <hbo-control-messages [control]="userForm.get('entityId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'role-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.ROLE' | translate }} *</label>
        <div class="col-sm-7">
          <select class="form-control-plaintext" [id]="'roleId-' + user.id" formControlName="roleId">
            <option value="1" [hidden]="currentUser.roleId !== 1">{{ 'ROLE.1' | translate }}</option>
            <option value="2" [hidden]="currentUser.roleId !== 1">{{ 'ROLE.2' | translate }}</option>
            <option value="3">{{ 'ROLE.3' | translate }}</option>
            <option value="4">{{ 'ROLE.4' | translate }}</option>
          </select>
          <hbo-control-messages [control]="userForm.get('roleId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3">
        <label [for]="'profile-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.PROFILE' | translate }} *</label>
        <div *ngIf="(currentUser.roleId !== 1 && currentUser.profileId == 2) || currentUser.roleId === 4 || (userForm.controls.id?.value | toNumber) === currentUser.id"
          class="col-sm-7 align_middle">
          {{'PROFILE.'+selectedProfile| translate}}
        </div>
        <div class="col-sm-7">
          <ng-select *ngIf="!((currentUser.roleId !== 1 && currentUser.profileId == 2 ) || currentUser.roleId === 4 || (userForm.controls.id?.value | toNumber) === currentUser.id)"
            [id]="'profileId-' + user.id" [searchable]="false" formControlName="profileId" labelForId="yesno"
            [(ngModel)]="selectedProfile" placeholder="{{'USER.PROFILE' | translate}}">
            <ng-option [value]="'1'">{{ 'PROFILE.1' | translate }}</ng-option>
            <ng-option [value]="'2'">{{ 'PROFILE.2' | translate }}</ng-option>
            <ng-option [value]="'3'" [disabled]="!((userForm.controls.roleId.value === '1' && currentUser.profileId === 3) || (userForm.controls.roleId.value === '2' && currentUser.roleId === 1))">
              {{ 'PROFILE.3' | translate }}
            </ng-option>
          </ng-select>
          <hbo-control-messages [control]="userForm.get('profileId')!"></hbo-control-messages>
        </div>
      </div>

      <!-- Se muestra el horizonsTeam si el usuario logado es admin y el usuario a visualizar/editar tiene rol admin o si se esta creando uno y el valor seleccionado de rol es admin  -->
      <div class="row mb-3"
        *ngIf="currentUser.roleId === 1 && userForm.controls.roleId.value === '1' && userForm.controls.profileId.value !== '3'">
        <label [for]="'horizonsTeamId-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.HORIZONS_TEAM' | translate
          }} *</label>
        <div *ngIf="!horizonsTeams.length" class="col-sm-7 align_middle">
          {{currentUser.horizonsTeam?.name}}
        </div>
        <div class="col-sm-7">
          <ng-select *ngIf="horizonsTeams.length" [id]="'horizonsTeamId-' + user.id" [searchable]="false"
            formControlName="horizonsTeamId" labelForId="yesno" [(ngModel)]="selectedHorizonsTeam"
            placeholder="{{'COMMON.HORIZONS_TEAM' | translate}}">
            <ng-option [value]="0">{{'COMMON.ALL' | translate}}</ng-option>
            <ng-option *ngFor="let horizonsTeam of horizonsTeams"
              [value]="horizonsTeam.id">{{horizonsTeam.name}}</ng-option>
          </ng-select>
          <hbo-control-messages [control]="userForm.get('horizonsTeamId')!"></hbo-control-messages>
        </div>
      </div>

      <div class="row mb-3"
        *ngIf="action === 'detail' && currentUser.roleId === 2 && userForm.controls.roleId.value === '2'">
        <label [for]="'teamId-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.TEAM' | translate }} *</label>
        <div class="col-sm-7 align_middle">
          <span class="form-control-plaintext">{{ currentUser.team?.name || ('COMMON.ALL' | translate) }}</span>
        </div>
      </div>

      <!-- Se muestra el team si el usuario a visualizar/editar tiene rol distribuidor/oficinaCentral o si se esta creando uno y el valor seleccionado de rol es distribuidor/oficinaCentral  -->
      <!--*ngIf="userForm.controls.entityId?.value && ([1,2,3].includes(user.roleId) || ( action === 'create' && ['2','3'].includes(userForm.controls.roleId.value)))"-->
      <div class="row mb-3"
        *ngIf="(
          !currentUser.teamId && (userForm.controls.id?.value | toNumber) !== currentUser.id && (['2','3','4'].includes(userForm.controls.roleId?.value!) 
        || ( action === 'create' && ['2','3','4'].includes(userForm.controls.roleId.value)))
        )
        && !(userForm.controls.roleId.value === '2' && userForm.controls.profileId.value === '3')
        || ( action !== 'create' && userForm.controls.roleId.value === '4')">
        <label [for]="'team-' + user.id" class="col-sm-5 col-form-label">{{ 'USER.TEAM' | translate }}</label>
        <div *ngIf="!partialTeams.length" class="col-sm-7 align_middle">
          {{head_office_herency_team || ('COMMON.ALL' | translate)}}
        </div>
        <div class="col-sm-7">
          <!-- simple: el resto de roles, que heredan el team de su entidad -->
          <ng-select *ngIf="partialTeams.length && userForm.controls.roleId.value !== '2'" [id]="'teamId-' + user.id" [searchable]="false"
            formControlName="teamId" labelForId="yesno" [(ngModel)]="selectedTeam" [clearable]="false"
            placeholder="{{'COMMON.TEAM' | translate}}"
            [readonly]="(currentUser.roleId === 2 && currentUser.profileId===2) ? true : false">
            <ng-option [value]="0">{{'COMMON.ALL' | translate}}</ng-option>
            <ng-option *ngFor="let team of partialTeams" [value]="team.id">{{team.name}}</ng-option>
          </ng-select>
          <!-- multi: solo rol distribuidor -->
          <ng-select *ngIf="partialTeams.length && userForm.controls.roleId.value === '2'"
            [multiple]="true" [searchable]="false" [clearable]="true"
            formControlName="teamIds"
            placeholder="{{'COMMON.TEAM' | translate}}"
            [items]="assignableTeams" bindLabel="name" bindValue="id">
          </ng-select>
          <hbo-control-messages [control]="userForm.get('teamId')!"></hbo-control-messages>
        </div>
      </div>

    </div>

  </div>
  <div class="p-4" *ngIf="currentUser.profileId !== 2 && !(currentUser.profileId === 1 && action === 'edit' && user.entityId === currentUser.entityId)">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate
      }}</button>
    <button type="submit" class="btn btn-dark" [ngClass]="{'submit-pb-disabled':!userForm.valid}">{{
      'COMMON.SAVE_CHANGES' | translate }}</button>
    <button type="button" class="btn btn-outline-secondary float-end" data-bs-toggle="modal"
      [attr.data-bs-target]="'#confirmationModal-' + user.id" *ngIf="action === 'edit' && !(user.roleId === 1 && user.username === 'admin')">
      <i class="bi bi-trash3"></i> {{ 'COMMON.DELETE' | translate }}
    </button>
  </div>
</form>

<hbo-confirmation-modal *ngIf="user" [id]="user.id" (confirm)="delete()"></hbo-confirmation-modal>